import { LoginCred } from "modules/register-login";
import { API_endpoints } from "../config"; 

export const loginUser = async (loginData: LoginCred): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.loginSubmit, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(loginData),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data.message || "Fehler beim Login.");
        }
        return await response.json();
        
    } catch (error) {
        console.error("Fehler beim Login:", error);
    }
};